import REST from "./rest/rest";

export function adminLogin(credentials) {
  return REST.post("user/adminLogin", credentials);
}
